import { render } from "./HeroiconsOutlineSelector.vue?vue&type=template&id=776b4f57"
const script = {}

import exportComponent from "E:\\Work\\wynajmy\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineSelector.vue"]])

export default __exports__